export default __webpack_public_path__ + "static/media/telegram-icon.abe3d6f2.svg";